import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { HashRouter } from "react-router-dom";

const reactAppData = window.rpReactPlugin || {};

const username = (reactAppData && reactAppData.username) ? reactAppData.username : null;
//const {username } = (reactAppData && reactAppData.username) ? reactAppData : {username:'mango.beret'};
const wpApiKey = (reactAppData && reactAppData.wpApiKey) ? reactAppData.wpApiKey : null;

const root = ReactDOM.createRoot(
  document.getElementById(process.env.REACT_APP_TARGET)
);
root.render(
  <React.StrictMode>
    <HashRouter>
    <App username = {username} wpApiKey={wpApiKey} />
    </HashRouter>
  </React.StrictMode>
);
